import type { PortalDashboard } from "./clientPortalApi";

type ParticipationSource = { applicationCode?: "booking" | "tickets"; participationMode?: "registration" | "admission"; ticketsEnabled?: boolean };

export function isAdmissionEvent(event: ParticipationSource): boolean {
  return event.participationMode === undefined ? event.applicationCode === "tickets" : event.participationMode === "admission";
}

export function hasEventTickets(event: ParticipationSource): boolean {
  return event.ticketsEnabled ?? event.applicationCode === "tickets";
}

export function portalParticipationKinds(dashboard: PortalDashboard) {
  const entries = [...(dashboard.events ?? []).map((item) => item.event), ...dashboard.bookings];
  const registration = entries.some((item) => !hasEventTickets(item)) || dashboard.bookingPortals.length > 0;
  const admission = entries.some(hasEventTickets) || (!registration && dashboard.allowedApplicationCodes.includes("tickets"));
  return { registration, admission };
}
